import { render, staticRenderFns } from "./LegacyAccountUpgradeButton.vue?vue&type=template&id=4031408b&scoped=true&"
import script from "./LegacyAccountUpgradeButton.vue?vue&type=script&lang=ts&"
export * from "./LegacyAccountUpgradeButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031408b",
  null
  
)

export default component.exports